<template>
  <div :class="this.isMobile.value ? 'login-backend-mobile' : 'login-backend'">
    <!-- 注册 -->
    <div class="register">
      <div class="register-step">
        <!-- <h2 class="title">{{ title }}</h2> -->
        <el-steps
          :space="600"
          :active="active"
          finish-status="success"
          :align-center="true"
        >
          <el-step title="注册信息" description="填写基本的注册账号信息">
          </el-step>
          <el-step
            title="完善公司信息"
            description="填写公司相关信息"
          ></el-step>
          <el-step title="注册完成" description=""></el-step>
        </el-steps>
      </div>

      <!-- 注册信息 -->
      <div class="register-wrapper" v-if="active == 0">
        <el-form :rules="rules" ref="form" label-width="80px" :model="form">
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item prop="fullName">
                <el-input
                  class="text-input"
                  placeholder="请输入您的身份证姓名"
                  v-model="form.fullName"
                  prefix-icon="el-icon-user-solid"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8"> <em>*</em>请采用身份证姓名</el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item prop="userName">
                <el-input
                  class="text-input"
                  placeholder="请输入您的身份证号码"
                  v-model="form.userName"
                  prefix-icon="el-icon-user-solid"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8"
              ><em>*</em>请填写有效身份证号码作为下次登录使用</el-col
            >
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item prop="confirmUserName">
                <el-input
                  class="text-input"
                  placeholder="请再次输入您的身份证号"
                  v-model="form.confirmUserName"
                  prefix-icon="el-icon-user-solid"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8"
              ><em>*</em>请再一次输入身份证号码进行身份证号确认</el-col
            >
          </el-row>

          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item prop="email">
                <el-input
                  class="text-input"
                  placeholder="请输入您的邮箱"
                  v-model="form.email"
                  prefix-icon="el-icon-message"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8"
            ><em>*</em>请输入您的邮箱用于消息接收</el-col
            >
          </el-row>
<!--          <el-row :gutter="20">-->
<!--            <el-col :span="16">-->
<!--              <el-form-item prop="password">-->
<!--                <el-input-->
<!--                  class="text-input"-->
<!--                  placeholder="设置密码"-->
<!--                  v-model="form.password"-->
<!--                  type="password"-->
<!--                  prefix-icon="el-icon-view"-->
<!--                />-->
<!--              </el-form-item>-->
<!--            </el-col>-->
<!--            <el-col :span="8"><em>*</em>6-20位字符</el-col>-->
<!--          </el-row>-->
<!--          <el-row :gutter="20">-->
<!--            <el-col :span="16">-->
<!--              <el-form-item prop="confirmPassword">-->
<!--                <el-input-->
<!--                  class="text-input"-->
<!--                  placeholder="密码确认"-->
<!--                  v-model="form.confirmPassword"-->
<!--                  type="password"-->
<!--                  prefix-icon="el-icon-view"-->
<!--                />-->
<!--              </el-form-item>-->
<!--            </el-col>-->
<!--            <el-col :span="8"><em>*</em>请再一次输入密码进行密码确认</el-col>-->
<!--          </el-row>-->
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item prop="phoneNumber">
                <el-input
                  class="text-input"
                  placeholder="手机号码"
                  v-model="form.phoneNumber"
                  prefix-icon="el-icon-view"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8"><em>*</em>请输入能正常接收信息的手机号码</el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item prop="phoneCode">
                <el-input
                  placeholder="请输入您接收的短信验证码"
                  v-model="form.phoneCode"
                ></el-input>
                <button
                  @click.prevent="getCode()"
                  class="code-btn"
                  :disabled="!show"
                >
                  <span v-show="show">获取验证码</span>
                  <span v-show="!show" class="count">{{ count }} s</span>
                </button>
              </el-form-item>
            </el-col>
            <el-col :span="8"><em>*</em>请注意查收短信验证码</el-col>
          </el-row>
        </el-form>
        <el-button type="danger" round class="login-button" @click="register"
          >开始注册</el-button
        >
        <el-checkbox v-model="agreePrivacy"><el-link type="danger" class="reset-tip" @click="toPrivacy"
        >登录即同意隐私协议</el-link></el-checkbox>
        <el-link type="success" class="login-tip" @click="changeType"
          >已有账号？去登陆</el-link
        >
      </div>

      <!-- 扫码关注 -->
      <div class="register-wrapper" v-if="active == 1">
        <el-form :rules="rulesCompany" ref="formCompany" label-width="160px" :model="formCompany">
          <el-form-item label="公司中文名称" prop="companyName">
            <el-input v-model="formCompany.companyName" placeholder="请输入公司中文名称" />
          </el-form-item>
<!--          <el-form-item prop="registeredCapital">-->
<!--            <span slot="label">-->
<!--                <span>注册资金</span>-->
<!--                <span style="color: red">(万元)</span>-->
<!--              </span>-->
<!--            <el-input v-model="formCompany.registeredCapital" type="number" placeholder="请输入注册资金(万元)" />-->
<!--          </el-form-item>-->
<!--          <el-form-item label="公司注册成立日期" prop="registeredDate">-->
<!--            <el-date-picker clearable size="small" style="width: 100%"-->
<!--                            v-model="formCompany.registeredDate"-->
<!--                            type="date"-->
<!--                            value-format="yyyy-MM-dd"-->
<!--                            placeholder="选择公司注册成立日期">-->
<!--            </el-date-picker>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="公司详细地址" prop="companyAddress">-->
<!--            <el-input v-model="formCompany.companyAddress" placeholder="请输入公司详细地址" />-->
<!--          </el-form-item>-->
<!--          <el-form-item label="公司性质" prop="companyType">-->
<!--            <el-select v-model="formCompany.companyType" placeholder="请选择公司性质">-->
<!--              <el-option-->
<!--                v-for="dict in companyTypeOptions"-->
<!--                :key="dict.dictValue"-->
<!--                :label="dict.dictLabel"-->
<!--                :value="parseInt(dict.dictValue)"-->
<!--              ></el-option>-->
<!--            </el-select>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="经营范围" prop="companyScope">-->
<!--            <el-input v-model="formCompany.companyScope" type="textarea" placeholder="请输入内容" />-->
<!--          </el-form-item>-->
<!--          <el-form-item label="授权品牌" prop="licensedBrand">-->
<!--            <el-input v-model="formCompany.licensedBrand" placeholder="请输入授权品牌" />-->
<!--          </el-form-item>-->
<!--          <el-form-item label="统一社会信用代码" prop="uniformSocialCreditCode">-->
<!--            <el-input v-model="formCompany.uniformSocialCreditCode" placeholder="请输入统一社会信用代码" />-->
<!--          </el-form-item>-->
<!--          <el-form-item label="营业执照有效期至" prop="businessLicenseDate">-->
<!--            <el-date-picker clearable size="small" style="width: 100%"-->
<!--                            v-model="formCompany.businessLicenseDate"-->
<!--                            type="date"-->
<!--                            value-format="yyyy-MM-dd"-->
<!--                            placeholder="选择营业执照有效期至">-->
<!--            </el-date-picker>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="法人名称" prop="legalName">-->
<!--            <el-input v-model="formCompany.legalName" placeholder="请输入法人名称" />-->
<!--          </el-form-item>-->
<!--          <el-form-item label="法人身份证号码" prop="legalIdCard">-->
<!--            <el-input v-model="formCompany.legalIdCard" placeholder="请输入法人身份证号码" />-->
<!--          </el-form-item>-->
<!--          <el-form-item label="公司信息状态" prop="status">-->
<!--            <el-select v-model="formCompany.status" placeholder="请选择公司信息状态">-->
<!--              <el-option-->
<!--                v-for="dict in statusOptions"-->
<!--                :key="dict.dictValue"-->
<!--                :label="dict.dictLabel"-->
<!--                :value="parseInt(dict.dictValue)"-->
<!--              ></el-option>-->
<!--            </el-select>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="基本账户开户银行" prop="bankName">-->
<!--            <el-input v-model="formCompany.bankName" placeholder="请输入基本账户开户银行" />-->
<!--          </el-form-item>-->
<!--          <el-form-item label="银行账号" prop="bankAccount">-->
<!--            <el-input v-model="formCompany.bankAccount" placeholder="请输入银行账号" />-->
<!--          </el-form-item>-->
<!--          <el-form-item label="是否为一般纳税人" prop="generalTaxpayer">-->
<!--            <el-select v-model="formCompany.generalTaxpayer" placeholder="请选择是否为一般纳税人">-->
<!--              <el-option-->
<!--                v-for="dict in generalTaxpayerOptions"-->
<!--                :key="dict.dictValue"-->
<!--                :label="dict.dictLabel"-->
<!--                :value="parseInt(dict.dictValue)"-->
<!--              ></el-option>-->
<!--            </el-select>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="纳税人识别号" prop="taxpayerCode">-->
<!--            <el-input v-model="formCompany.taxpayerCode" placeholder="请输入纳税人识别号" />-->
<!--          </el-form-item>-->
<!--          <el-form-item label="是否三证合一" prop="threeCertificates">-->
<!--            <el-select v-model="formCompany.threeCertificates" placeholder="请选择是否三证合一">-->
<!--              <el-option-->
<!--                v-for="dict in threeCertificatesOptions"-->
<!--                :key="dict.dictValue"-->
<!--                :label="dict.dictLabel"-->
<!--                :value="parseInt(dict.dictValue)"-->
<!--              ></el-option>-->
<!--            </el-select>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="股东信息" prop="shareholderInformation">-->
<!--            <el-input v-model="formCompany.shareholderInformation" placeholder="请输入股东信息" />-->
<!--          </el-form-item>-->
          <el-form-item label="供应商入库类型" prop="materialTypes">
            <treeselect
              v-model="formCompany.materialTypes"
              :options="materialTypeOptions"
              :disable-branch-nodes="true"
              :show-count="true"
              placeholder="请选择供应商入库类型"
              multiple
              collapseTags
            >
              <div slot="value-label" slot-scope="{ node }">{{ node.raw.position }}</div>
            </treeselect>
          </el-form-item>
<!--          <el-divider></el-divider>-->
<!--          <h3> 附件上传说明：请上传1.一般纳税人资格证书，2.税务登记证，3.营业执照电子版，4.组织机构代码证，5.开户行信息，6.<a href="/template/companyLicense.docx">公司授权书(点击下载模板)，7.供应商入库类型证明文件</a></h3>-->
<!--          <el-divider></el-divider>-->
<!--          <el-form-item label="附件" prop="applyFileList">-->
<!--            <el-upload-->
<!--              ref="fileUpload"-->
<!--              :limit="10"-->
<!--              accept=".jpg, .png, .jpeg, .pdf"-->
<!--              multiple-->
<!--              :on-exceed="fileLimitCallback"-->
<!--              :action="upload.url"-->
<!--              :headers="upload.headers"-->
<!--              :file-list="applyFileList"-->
<!--              :on-progress="handleFileUploadProgress"-->
<!--              :before-upload="onBeforeUpload"-->
<!--              :on-change="handleFileChange"-->
<!--              :on-success="-->
<!--                  (response, file, fileList) =>-->
<!--                    uploadFileSuccess(response, file, fileList)-->
<!--                "-->
<!--              :on-error="handleFileError"-->
<!--              :on-preview="handlePreview"-->
<!--              :on-remove="-->
<!--                  (file, fileList) => removeFileSuccess(file, fileList)-->
<!--                "-->
<!--              :auto-upload="false"-->
<!--              :disabled="disabled"-->
<!--            >-->
<!--              <el-button slot="trigger" size="small" type="primary" v-if="!disabled"-->
<!--              >选取文件</el-button-->
<!--              >-->
<!--              <el-button-->
<!--                style="margin-left: 10px"-->
<!--                size="small"-->
<!--                type="success"-->
<!--                :loading="upload.isUploading"-->
<!--                @click="submitUpload()"-->
<!--                v-if="!disabled"-->
<!--              >上传</el-button-->
<!--              >-->
<!--              <div slot="tip" class="el-upload__tip" v-if="!disabled">支持PDF、图片格式文件,200M以内</div>-->
<!--            </el-upload>-->
<!--          </el-form-item>-->
        </el-form>
        <el-button type="danger" round class="login-button" @click="submitCompanyForm"
        >提交公司信息</el-button
        >
      </div>
      <!-- 注册完成 -->
      <div class="register-wrapper" v-if="active == 2">
        <div class="step-container">
<!--          <el-divider>绑定步骤</el-divider>-->
<!--          <div>-->
<!--            <ul>-->
<!--              <li>1、关注【赣州产控集团】公众号。</li>-->
<!--              <li>-->
<!--                2、进入公众号，点击【产控招聘】菜单栏，进入到【绑定解绑】子菜单。-->
<!--              </li>-->
<!--              <li>3、输入您的用户名密码并点击绑定，系统提示绑定成功即可。</li>-->
<!--            </ul>-->
<!--          </div>-->
          <!-- <div>
            你将在<span style="color: red">{{ countTime }}</span
            >秒后进入系统
          </div> -->
          <el-button
            type="danger"
            round
            class="login-button"
            @click="changeType"
            >去登录</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isIdentityId } from "@/utils/validate";
import { register } from "@/api/user";
import { sendCode } from "@/api/sms";
import {getDicts} from "@/utils/data";
import { listCompany, getCompany, delCompany, addCompany, updateCompany } from "@/api/purchase/company";
import { treeselect } from "@/api/purchase/purchaseMaterialType";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { getToken } from "@/utils/auth";
export default {
  name: "register",
  components: {
    Treeselect
  },
  data() {
    return {
      title: "赣州产控电子采购平台",
      active: 0,
      countTime: 0, // 倒计时
      timers: null,
      form: {
        userName: "",
        confirmUserName: "",
        fullName: "",
        password: "",
        confirmPassword: "",
        phoneNumber: "",
        phoneCode: "",
      },
      //初始值
      show: "false",
      count: "",
      loading: false,
      redirect: undefined,
      rules: {
        fullName: [
          { required: true, trigger: "blur", message: "请输入姓名" },
          {
            validator(rule, value, callback) {
              if(!/^[\u4E00-\u9FA5]{1,5}$/.test(value)){
                callback(new Error("请输入您的身份证姓名"));
              }
              callback();
            },
            trigger: "blur",
          }
        ],
        userName: [
          {
            required: true,
            trigger: "blur",
            message: "请输入身份证号",
          },
          {
            validator(rule, value, callback) {
              var errorMsg = isIdentityId(value);
              if (errorMsg != "") {
                callback(new Error(errorMsg));
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        confirmUserName: [{
          required: true,
          trigger: "blur",
          message: "请输入身份证号确认",
        }],
        password: [
          { required: true, trigger: "blur", message: "请输入密码" },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            trigger: "blur",
            message: "请输入邮箱",
          },
          {
            validator(rule, value, callback) {
              if (!/^\w+@[a-zA-Z0-9]{2,10}(?:\.[a-z]{2,4}){1,3}$/.test(value)) {
                callback(new Error("请输入合法的邮箱"));
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        confirmPassword: {
          required: true,
          trigger: "blur",
          message: "请输入密码确认",
        },
        phoneCode: {
          required: true,
          trigger: "blur",
          message: "请输入短信验证码",
        },
        phoneNumber: [
          {
            required: true,
            trigger: "blur",
            message: "请输入手机号",
          },
          {
            validator(rule, value, callback) {
              if (!/^\d{11}$/.test(value)) {
                callback(new Error("请输入合法的手机号"));
              }
              callback();
            },
            trigger: "blur",
          },
        ],
      },
      rulesCompany: {
        companyName: [
          { required: true, message: "公司中文名称不能为空", trigger: "blur" }
        ],
        registeredCapital: [
          { required: true, message: "注册资金(万元)不能为空", trigger: "blur" }
        ],
        registeredDate: [
          { required: true, message: "公司注册成立日期不能为空", trigger: "blur" }
        ],
        companyAddress: [
          { required: true, message: "公司详细地址不能为空", trigger: "blur" }
        ],
        companyType: [
          { required: true, message: "公司性质不能为空", trigger: "change" }
        ],
        companyScope: [
          { required: true, message: "经营范围不能为空", trigger: "blur" }
        ],
        licensedBrand: [
          { required: true, message: "授权品牌不能为空", trigger: "blur" }
        ],
        uniformSocialCreditCode: [
          { required: true, message: "统一社会信用代码不能为空", trigger: "blur" },
          {
            validator(rule, value, callback) {
              let arr = value.split(" ");
              if(arr.length != 1){
                callback(new Error("不能含有空格"));
              }
              callback();
            },
            trigger: "blur",
          }
        ],
        businessLicenseDate: [
          { required: true, message: "营业执照有效期至不能为空", trigger: "blur" }
        ],
        legalName: [
          { required: true, message: "法人名称不能为空", trigger: "blur" }
        ],
        legalIdCard: [
          { required: true, message: "法人身份证号码不能为空", trigger: "blur" },
          {
            validator(rule, value, callback) {
              let arr = value.split(" ");
              if(arr.length != 1){
                callback(new Error("不能含有空格"));
              }
              callback();
            },
            trigger: "blur",
          }
        ],
        bankName: [
          { required: true, message: "基本账户开户银行不能为空", trigger: "blur" }
        ],
        bankAccount: [
          { required: true, message: "银行账号不能为空", trigger: "blur" },
          {
            validator(rule, value, callback) {
              let arr = value.split(" ");
              if(arr.length != 1){
                callback(new Error("不能含有空格"));
              }
              callback();
            },
            trigger: "blur",
          }
        ],
        generalTaxpayer: [
          { required: true, message: "是否为一般纳税人不能为空", trigger: "change" }
        ],
        taxpayerCode: [
          { required: true, message: "纳税人识别号不能为空", trigger: "blur" },
          {
            validator(rule, value, callback) {
              let arr = value.split(" ");
              if(arr.length != 1){
                callback(new Error("不能含有空格"));
              }
              callback();
            },
            trigger: "blur",
          }
        ],
        threeCertificates: [
          { required: true, message: "是否三证合一不能为空", trigger: "change" }
        ],
        shareholderInformation: [
          { required: true, message: "股东信息不能为空", trigger: "blur" }
        ],
        materialTypes: [{ required: true, trigger: "blur", message: "请输入供应商入库类型" }],
      },
      formCompany: {

      },
      // 公司性质字典
      companyTypeOptions: [],
      // 公司信息状态字典
      statusOptions: [],
      // 是否为一般纳税人字典
      generalTaxpayerOptions: [],
      // 是否三证合一字典
      threeCertificatesOptions: [],
      upload: {
        // 是否禁用上传
        isUploading: false,
        // 设置上传的请求头部
        headers: { Authorization: "Bearer " + getToken() },
        // 上传的地址
        url: process.env.VUE_APP_BASE_API + "/api/purchase/file/upload",
        // 上传的文件列表
        fileList: [],
      },
      // agreeingFileList: [],
      // companyLicenseFileList: [],
      // bankFileList: [],
      // organizationFileList: [],
      // businessLicenseFileList: [],
      // taxRegistrationCertificateFileList: [],
      // taxpayerCertificateFileList: [],
      applyFileList: [],
      disabled: false,
      materialTypeOptions: [],
      agreePrivacy: false,
    };
  },

  mounted() {},

  updated() {},

  computed: {},

  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  created() {
    // getDicts("purchase_company_type").then(response => {
    //   this.companyTypeOptions = response.data;
    // });
    // getDicts("purchase_apply_status").then(response => {
    //   this.statusOptions = response.data;
    // });
    // getDicts("purchase_yes_or_no").then(response => {
    //   this.generalTaxpayerOptions = response.data;
    // });
    // getDicts("purchase_yes_or_no").then(response => {
    //   this.threeCertificatesOptions = response.data;
    // });

    this.getTreeselect();
  },

  methods: {
    toPrivacy() {
      location.href = `https://cloud.xizinet.com/assets/public/purchase/xizi_privacy.html`;
    },
    /** 查询下拉树结构 */
    getTreeselect() {
      treeselect().then(response => {
        this.materialTypeOptions = response.data;
      });
    },
    // 注册
    register() {
      if(!this.agreePrivacy){
        this.$message({
          message: "请同意隐私条款",
          type: "error",
        });
        return;
      }
      this.$refs["form"].validate(valid => {
        if (valid) {
          var data = {
            userName: this.form.userName,
            confirmUserName: this.form.confirmUserName,
            fullName: this.form.fullName,
            password: this.form.password,
            confirmPassword: this.form.confirmPassword,
            phoneNumber: this.form.phoneNumber,
            phoneCode: this.form.phoneCode,
            email: this.form.email,
          };
          console.log("register body:", data);
          register(data).then((response) => {
            console.log(response);
            if (response.code == 200) {
              this.formCompany.userUuid = response.data.uuid;
              this.reset();
              this.nextStep();
              //this.toLogin = true;
            }
          });
        }
      });
    },
    changeType() {
      this.$router.push("/login");
    },
    // 表单重置
    reset() {
      this.form = {
        userName: "",
        confirmUserName: "",
        fullName: "",
        password: "",
        confirmPassword: "",
        phoneNumber: "",
        phoneCode: "",
        email: "",
      };
    },
    // 重置附件列表
    // resetFileList() {
    //   this.agreeingFileList = [];
    //   this.companyLicenseFileList = [];
    //   this.bankFileList = [];
    //   this.organizationFileList = [];
    //   this.businessLicenseFileList = [];
    //   this.taxRegistrationCertificateFileList = [];
    //   this.taxpayerCertificateFileList = [];
    // },

    //查询附件
    // queryFile(params) {
    //   queryFileByUuid(params).then((response) => {
    //       this.resetFileList();
    //       let data = response.data;
    //       for (let i = 0; i < data.length; i++) {
    //         if (data[i].fileType === 11) {
    //           let taxpayerCertificate = {
    //             name: data[i].fileName,
    //             url: data[i].fileUrl
    //           }
    //           this.taxpayerCertificateFileList.push(taxpayerCertificate);
    //         } else if (data[i].fileType === 12) {
    //           let taxRegistrationCertificate = {
    //             name: data[i].fileName,
    //             url: data[i].fileUrl
    //           }
    //           this.taxRegistrationCertificateFileList.push(taxRegistrationCertificate);
    //         } else if (data[i].fileType === 13) {
    //           let businessLicense = {
    //             name: data[i].fileName,
    //             url: data[i].fileUrl
    //           }
    //           this.businessLicenseFileList.push(businessLicense);
    //         } else if (data[i].fileType === 14) {
    //           let organization = {
    //             name: data[i].fileName,
    //             url: data[i].fileUrl
    //           }
    //           this.organizationFileList.push(organization);
    //         } else if (data[i].fileType === 5) {
    //           let bank = {
    //             name: data[i].fileName,
    //             url: data[i].fileUrl
    //           }
    //           this.bankFileList.push(bank);
    //         } else if (data[i].fileType === 16) {
    //           let companyLicense = {
    //             name: data[i].fileName,
    //             url: data[i].fileUrl
    //           }
    //           this.companyLicenseFileList.push(companyLicense);
    //         } else if (data[i].fileType === 17) {
    //           let agreeing = {
    //             name: data[i].fileName,
    //             url: data[i].fileUrl
    //           }
    //           this.agreeingFileList.push(agreeing);
    //         }
    //       }
    //     }
    //   );
    // },

    // 文件超出个数限制时的钩子函数
    fileLimitCallback(files, fileList) {
      this.$message.warning(`当前限制最多选择 10 个文件`);
    },
    onBeforeUpload(file) {
      const isLt200M = file.size / 1024 / 1024 < 200;
      if (!isLt200M) {
        this.$message.error("上传文件大小不能超过 200M!");
        return false;
      }
      return true;
    },
    handleFileChange(file, fileList) {
    },
    // 文件上传中处理
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },
    // 文件超出个数限制时的钩子函数
    importExcelLimitCallbck() {
      this.$message.warning(`当前限制最多导入 1 个文件`);
    },
    // 处理附件上传
    uploadFileSuccess(response, file, fileList) {
      this.upload.isUploading = false;
      if (response != null && response.code == 200) {
        let files = [];
        fileList.forEach(function (val, index) {
          if(val.response){
            files.push(val.response.data);
          }else {
            files.push(val);
          }

        });
        this.applyFileList = files;
        this.$message.success("上传成功");
      } else {
        this.$message.error(response.msg);
      }
    },
    // 文件上传失败处理
    handleFileError(err, file, fileList) {
      this.upload.isUploading = false;
      this.$message.error("文件上传失败");
    },
    // 处理附件移除
    removeFileSuccess(file, fileList) {
      this.applyFileList = fileList;
    },
    // 文件提交处理
    submitUpload() {
      this.$refs.fileUpload.submit();
    },
    // 文件预览
    handlePreview(file) {
      window.open(file.url);
    },

    /** 提交公司信息按钮 */
    submitCompanyForm() {
      // if(this.applyFileList < 1){
      //   this.$message({
      //     message: "请上传1.一般纳税人资格证书，2.税务登记证，3.营业执照电子版，4.组织机构代码证，5.开户行信息，6.公司授权书，7.供应商入库类型证明文件",
      //     type: "warning",
      //   });
      //   return;
      // }
      this.$refs["formCompany"].validate(valid => {
        if (valid) {
          this.formCompany.applyFileList = this.applyFileList;
          addCompany(this.formCompany).then(response => {
            if (response.code == 200) {
              this.resetCompany();
              this.nextStep();
            }
          });
        }
      });
    },
    resetCompany() {
      this.formCompany = {
        id: null,
        companyName: null,
        registeredCapital: null,
        registeredDate: null,
        companyAddress: null,
        companyType: null,
        companyScope: null,
        licensedBrand: null,
        uniformSocialCreditCode: null,
        businessLicenseDate: null,
        legalName: null,
        legalIdCard: null,
        procStatus: null,
        bankName: null,
        bankAccount: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        version: null,
        uuid: null,
        userUuid: null,
        generalTaxpayer: null,
        taxpayerCode: null,
        shareholderInformation: null,
        threeCertificates: null,
        applyFileList: null
      };
    },
    // 获取短信验证码
    getCode() {
      //axios请求
      console.log(this.form.phoneNumber);
      var phoneReg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      if (!phoneReg.test(this.form.phoneNumber)) {
        this.$message({
          message: "请填写合法的手机号码",
          type: "warning",
        });
      } else {
        // 验证码倒计时
        if (!this.timers) {
          this.count = 60;
          this.show = false;
          this.timers = setInterval(() => {
            if (this.count > 0 && this.count <= 60) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timesr);
              this.timers = null;
            }
          }, 1000);
        }
        var query = {
          phoneNumber: this.form.phoneNumber,
        };
        sendCode(query).then((res) => {
          if (res.data === "sendSuccess") {
            this.$message({
              message: "短信已发送",
              type: "success",
            });
          } else {
             this.$message.error('短信发送失败');
          }
        });
      }
    },

    // 倒计时
    // countDown() {
    //   const count = 3;
    //   this.countTime = count;
    //   this.timers = setInterval(() => {
    //     if (this.countTime > 0) {
    //       this.countTime--;
    //     } else {
    //       clearInterval(this.timers);
    //       this.$router.push("/login");
    //     }
    //   }, 1000);
    // },

    nextStep() {
      if (this.active == 0) {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            if (this.active++ > 2) {
              this.active = 0;
            }
          }
        });
      } else if (this.active == 1) {
        if (this.active++ > 2) {
          this.active = 0;
        }
        // this.countDown();
      } else {
        if (this.active++ > 2) {
          this.active = 0;
        }
      }
    },
  }, //methods end
};
</script>

<style scoped lang="less">
.login-backend {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding-top: 200px;
  .login-wrapper {
    width: 400px;
    height: 360px;
    // padding: 20px 10px;
    // box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
    .title {
      margin: 0px auto 30px auto;
      text-align: center;
      color: #707070;
    }
    .text-input {
      margin-bottom: 12px;
    }
    .login-button {
      margin-top: 30px;
      width: 100%;
    }
    .divider {
      margin-top: 10px;
      .line {
        width: 50px;
        border-top: 1px solid #878787;
      }
      .txt {
        margin: 0 10px;
        color: #878787;
        font-size: 14px;
        font-family: Helvetica Neue;
        line-height: 1.5;
      }
    }
    .other-account {
      .account-icon {
        width: 60px;
      }
    }
    .login-tip {
      margin-top: 10px;
      float: right;
      cursor: pointer;
    }
  }

  .gzh-img{
    display: flex;
    align-content: center;
    justify-content: center;
  }

  .step-container {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    font-size: 16px;
    line-height: 2;
    color: #707070;
  }

  .register {
    align-content: center;
    justify-content: center;
    font-size: 14px;
    line-height: 1.5;
    color: #707070;
  }

  .register-step {
    margin-top: -80px;
    margin-bottom: 20px;
    width: 800px;
  }
  // 注册
  .register-wrapper {
    width: 800px;
    //height: 460px;
    // padding: 20px 10px;
    // box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
    .title {
      margin: 0px auto 30px auto;
      text-align: center;
      color: #707070;
    }
    .text-input {
      margin-bottom: 10px;
    }
    .login-button {
      margin-top: 30px;
      width: 80%;
      margin-left: 72px;
    }
    .divider {
      margin-top: 10px;
      .line {
        width: 50px;
        border-top: 1px solid #878787;
      }
      .txt {
        margin: 0 10px;
        color: #878787;
        font-size: 14px;
        font-family: Helvetica Neue;
        line-height: 1.5;
      }
    }
    .login-tip {
      margin-top: 10px;
      float: right;
      cursor: pointer;
    }
    em {
      color: red;
      margin-right: 5px;
    }
  }

  // 短信验证码
  .pr {
    position: relative;
  }

  .code-btn {
    width: 100px;
    height: 20px;
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 222;
    //#ef8466橘色
    color: @main-color;
    font-size: 14px;
    border: none;
    border-left: 1px solid #bababa;
    padding-left: 10px;
    background-color: #fff;
    //鼠标指针的样式:伸出食指的手,default 箭头，crosshair 十字，progress 箭头和沙漏
    cursor: pointer;
  }
}

.login-backend-mobile {
  display: flex;
  flex-direction: row;
  align-content: stretch;
  justify-content: left;
  width: 100%;
  height: 100%;
  padding-top: 200px;
  .login-wrapper {
    width: 400px;
    height: 360px;
    // padding: 20px 10px;
    // box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
    .title {
      margin: 0px auto 30px auto;
      text-align: center;
      color: #707070;
    }
    .text-input {
      margin-bottom: 12px;
    }
    .login-button {
      margin-top: 30px;
      width: 100%;
    }
    .divider {
      margin-top: 10px;
      .line {
        width: 50px;
        border-top: 1px solid #878787;
      }
      .txt {
        margin: 0 10px;
        color: #878787;
        font-size: 14px;
        font-family: Helvetica Neue;
        line-height: 1.5;
      }
    }
    .other-account {
      .account-icon {
        width: 60px;
      }
    }
    .login-tip {
      margin-top: 10px;
      float: right;
      cursor: pointer;
    }
  }

  .gzh-img{
    display: flex;
    align-content: center;
    justify-content: center;
  }

  .step-container {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    font-size: 16px;
    line-height: 2;
    color: #707070;
  }

  .register {
    align-content: center;
    justify-content: center;
    font-size: 14px;
    line-height: 1.5;
    color: #707070;
  }

  .register-step {
    margin-top: -80px;
    margin-bottom: 20px;
  }
  // 注册
  .register-wrapper {
    //height: 460px;
    // padding: 20px 10px;
    // box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
    .title {
      margin: 0px auto 30px auto;
      text-align: center;
      color: #707070;
    }
    .text-input {
      margin-bottom: 10px;
    }
    .login-button {
      margin-top: 30px;
      width: 80%;
      margin-left: 72px;
    }
    .divider {
      margin-top: 10px;
      .line {
        width: 50px;
        border-top: 1px solid #878787;
      }
      .txt {
        margin: 0 10px;
        color: #878787;
        font-size: 14px;
        font-family: Helvetica Neue;
        line-height: 1.5;
      }
    }
    .login-tip {
      margin-top: 10px;
      float: right;
      cursor: pointer;
    }
    em {
      color: red;
      margin-right: 5px;
    }
  }

  // 短信验证码
  .pr {
    position: relative;
  }

  .code-btn {
    width: 100px;
    height: 20px;
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 222;
    //#ef8466橘色
    color: @main-color;
    font-size: 14px;
    border: none;
    border-left: 1px solid #bababa;
    padding-left: 10px;
    background-color: #fff;
    //鼠标指针的样式:伸出食指的手,default 箭头，crosshair 十字，progress 箭头和沙漏
    cursor: pointer;
  }
}
</style>
